/**
 * NBA confidence tooltip copy (PROD-570).
 *
 * Verbatim tooltip text shown on hover over an NBA card's confidence
 * percentage. Surfaces the calibration basis to clinicians and
 * regulators per master prompt v3.3 §What to Build §6 (Illustrative
 * Projection banner) and ADR-001 Layer 4 (NBA / JITAI surfaces).
 *
 * The NBA card primitive itself lands in PROD-572 (Phase 1 corrections)
 * + Phase 2 NBA build per docs/COMPONENT-CONTRACTS.md §9 (NbaCard).
 * Until then this constant is the single source of truth that the
 * eventual `<NbaCard>` confidence pill will consume.
 *
 * HC5: zero em dashes - this string uses hyphens / a period only.
 */
export const NBA_CONFIDENCE_TOOLTIP_TEXT =
  'Confidence calibration based on retrieval rank + structural validity. See methodology note.';
